module.exports = __webpack_public_path__ + "static/media/Empleados.89f55123.svg";